import styled from "styled-components";

export const DeliveryCreateHelpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.5rem;

  .help-text-regular,
  .help-text-semibold {
    margin: 0;
    font-size: 0.75rem;
    font-style: italic;
    color: #9ca3af;
    line-height: 1.4;
  }

  .help-text-semibold {
    font-weight: 600;
  }
`;

export const DeliveryCreateHelpText = styled.div`
  margin-top: 0.5rem;
  font-size: 0.75rem;
  font-style: italic;
  color: #9ca3af;
  line-height: 1.4;

  b,
  strong {
    font-weight: 600;
  }
`;
